import React from 'react';
import {
    Alert,
    Button,
    Box,
    Typography,
} from '@mui/material';
import {
    Refresh as RestartIcon,
    History as HistoryIcon,
} from '@mui/icons-material';

const SubmissionStatus = ({ 
    isSubmitted,
    submitSuccess, 
    error, 
    onRestart, 
    onViewHistory,
    submitting 
}) => {
    if (submitSuccess || isSubmitted) {
        return (
            <Alert 
                severity="success" 
                sx={{ 
                    mb: 4, 
                    borderRadius: 2,
                    '& .MuiAlert-message': { width: '100%' }
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { sm: 'center' }, gap: 2 }}>
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="h6" gutterBottom>
                            🎉 Topic completed successfully!
                        </Typography>
                        <Typography variant="body2">
                            You have completed this topic. You can restart if you want to try again or view your submission history.
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, flexDirection: { xs: 'column', sm: 'row' } }}>
                        <Button 
                            variant="outlined" 
                            onClick={onViewHistory}
                            startIcon={<HistoryIcon />}
                        >
                            View History
                        </Button>
                        <Button 
                            variant="contained" 
                            color="success" 
                            onClick={onRestart}
                            disabled={submitting}
                            startIcon={<RestartIcon />}
                        >
                            Try Again
                        </Button>
                    </Box>
                </Box>
            </Alert>
        );
    }

    if (error) {
        return (
            <Alert severity="error" sx={{ mb: 4 }}>
                {error}
            </Alert>
        );
    }

    return null;
};

export default SubmissionStatus;
